<template>
  <div
    class="dropdown-select-container"
    @click="toggleDropDown = !toggleDropDown"
  >
    {{ groupOptions[selectedGroup] }}
    <div class="selected-item" v-if="toggleDropDown">
      <ul>
        <li
          class="item-options"
          v-for="option in Object.keys(groupOptions)"
          :key="option"
          :value="option"
           @click="updateSelected(option)"
        >
          {{ groupOptions[option] }}
        </li>
      </ul>
    </div>
    <svg
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
        clip-rule="evenodd"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    groupOptions: {
      type: Object,
      requried: true,
    },
  },
  data() {
    return {
      toggleDropDown: false,
      selectedGroup: "my_clients",
    };
  },
  methods: {
     updateSelected(option) {
      this.selectedGroup = option;
      console.log(option);
      this.$eventBus.$emit("groupChanged", this.selectedGroup);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-select-container {
  position: relative;
  border: 1px solid #fff;
  border-radius: 0.25rem;
  color: #fff;
  padding: 0.7rem;
  text-align: left;
  font-size: 16px;

  &:hover {
      cursor: pointer;
  }

  .selected-item {
    position: absolute;
    color: black;
    background-color: #fff;
    left: 0;
    background: white;
    color: black;
    text-align: left;
    border-radius: 0.25rem;
    z-index: 100;
    font-size: 1rem;
    width: 100%;
    margin-top: 16px;
    box-shadow: rgb(149 157 165 / 20%) 0px 8px 24px;

    ul {
      list-style: none;
      padding: 0;
      padding-bottom: 8px;

      li {
        list-style: none;
        padding: 8px 20px;
        &:hover {
          background-color: #99999933;
          cursor: pointer;
        }
      }
    }
  }

  svg {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0.7rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>